import React from 'react';
import { arrayOf, bool, func, string } from 'prop-types';

import AddButton from '@johnlewispartnership/wtr-ingredients/ingredients/AddButton';
import Button from '@johnlewispartnership/wtr-ingredients/ingredients/Button';
import SmallButton from '@johnlewispartnership/wtr-ingredients/ingredients/SmallButton';
import { TextLink } from '@johnlewispartnership/wtr-ingredients/ingredients/TextLink';

import { setModalRoute } from 'components/Address/util';
import { AddButton as AddButtonFormField } from 'components/Forms/ReduxFormFields';

import urls from 'constants/urls';

import styles from './AddAddressButton.scss';

const addAddressButtonDefaultPropOnClick = () => {};
const addAddressButtonDefaultPropValidate = [];

const AddAddressButton = ({
  showAsLink = false,
  showAsPlaceholder = true,
  small = null,
  onClick = addAddressButtonDefaultPropOnClick,
  buttonMessage = 'Add an address',
  validate = addAddressButtonDefaultPropValidate,
}) => {
  const AddButtonOfType = validate.length !== 0 ? AddButtonFormField : AddButton;
  const AddAddressBtn = small ? SmallButton : Button;

  const onShowAddModal = event => {
    if (event) {
      event.preventDefault();
    }
    setModalRoute(urls.addressModals.add);
    onClick();
  };

  if (showAsLink) {
    return (
      <div className={styles.anchorLinkWrapper}>
        <TextLink
          component="button"
          onClick={onShowAddModal}
          data-test="add-address-button"
          className={styles.buttonAsLink}
        >
          {buttonMessage}
        </TextLink>
      </div>
    );
  }

  return showAsPlaceholder ? (
    <AddButtonOfType
      onClick={onShowAddModal}
      data-testid="add-address-button"
      label={buttonMessage}
      validate={validate}
    />
  ) : (
    <div className={styles.addAddressButton}>
      <AddAddressBtn
        label={buttonMessage}
        onClick={onShowAddModal}
        theme="secondary"
        width={small ? null : 'full'}
        data-testid="add-address-button"
      />
    </div>
  );
};

AddAddressButton.propTypes = {
  showAsLink: bool,
  showAsPlaceholder: bool,
  onClick: func,
  buttonMessage: string,
  small: bool,
  validate: arrayOf(func),
};

export default AddAddressButton;
